<div class="container">
    <div class="row mt-5">
        <div class="col-md-12">
            <div class="text-center">
                <h1>Lista Utenti</h1>
            </div>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-md-12 d-flex justify-content-end">
            <button class="btn btn-primary" (click)="aggiungiReport()">Aggiungi Report</button>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-md-12 text-center">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Account</th>
                        <th>Data</th>
                        <th>Market</th>
                        <td>Modifica</td>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let rep of reports">
                        <td>{{rep.id}}</td>
                        <td>{{rep.data}}</td>
                        <td>{{rep.market}}</td>
                        <td>
                            <a class="btn btn-primary" (click)="modificaReport(rep.id)">Modifica</a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
